import {
  Charsets_getInstance3jooo7e4x0j2x as Charsets_getInstance,
  encodeToByteArrayomtvgs5lyogm as encodeToByteArray,
} from '../charsets/Charset.js.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { encodeToByteArray1onwao0uakjfh as encodeToByteArray_0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { writeString33ca4btrgctw7 as writeString } from '../../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Utf8.mjs';
import { encodeToImpl35qnqj6vvbsjt as encodeToImpl } from '../charsets/Encoding.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function toByteArray(_this__u8e3s4, charset) {
  charset = charset === VOID ? Charsets_getInstance().f4m_1 : charset;
  if (charset.equals(Charsets_getInstance().f4m_1))
    return encodeToByteArray_0(_this__u8e3s4);
  return encodeToByteArray(charset.i4m(), _this__u8e3s4, 0, _this__u8e3s4.length);
}
function writeText(_this__u8e3s4, text, fromIndex, toIndex, charset) {
  fromIndex = fromIndex === VOID ? 0 : fromIndex;
  toIndex = toIndex === VOID ? charSequenceLength(text) : toIndex;
  charset = charset === VOID ? Charsets_getInstance().f4m_1 : charset;
  if (charset === Charsets_getInstance().f4m_1) {
    return writeString(_this__u8e3s4, toString(text), fromIndex, toIndex);
  }
  encodeToImpl(charset.i4m(), _this__u8e3s4, text, fromIndex, toIndex);
}
//region block: exports
export {
  toByteArray as toByteArray1i3ns5jnoqlv6,
  writeText as writeText19qfzm98fbm4l,
};
//endregion

//# sourceMappingURL=Strings.mjs.map
